// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetTrailersApiParameter } from "@store/Framework/Services/TrailerService";
import TrailerTrackingState from "@store/Framework/Store/Greif/Pages/TrailerTracking/TrailerTrackingState";
import { Draft } from "immer";

const initialState: TrailerTrackingState = {
    getTrailersParameter: {},
    incompleteGetTrailersParameter: {},
    filtersOpen: false,
    selectedTrailersIds: {},
};

const actions = {
    "Greif/Pages/TrailerTracking/UpdateSearchFields": (
        draft: Draft<TrailerTrackingState>,
        action: { parameter: GetTrailersApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getTrailersParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getTrailersParameter = { ...initialState.getTrailersParameter, ...action.parameter };
            draft.incompleteGetTrailersParameter = {};
        } else {
            draft.getTrailersParameter = { ...draft.getTrailersParameter, ...action.parameter };

            const skipProperties: (keyof GetTrailersApiParameter)[] = ["dwellTimeInDaysOperator", "dwellTimeInDays"];
            const skipPropertiesSet = new Set(skipProperties.map(o => o.toString()));
            for (const key in draft.getTrailersParameter) {
                const value = (<any>draft.getTrailersParameter)[key];

                if (skipPropertiesSet.has(key)) {
                    continue;
                }

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getTrailersParameter)[key];
                }
            }
        }
    },
    "Greif/Pages/TrailerTracking/UpdateTemporarySearchFields": (
        draft: Draft<TrailerTrackingState>,
        action: { parameter: GetTrailersApiParameter & UpdateSearchFieldsType },
    ) => {
        draft.incompleteGetTrailersParameter = { ...draft.incompleteGetTrailersParameter, ...action.parameter };
        if (
            draft.incompleteGetTrailersParameter.dwellTimeInDaysOperator &&
            (draft.incompleteGetTrailersParameter.dwellTimeInDays ||
                draft.incompleteGetTrailersParameter.dwellTimeInDays === 0)
        ) {
            draft.getTrailersParameter.dwellTimeInDaysOperator =
                draft.incompleteGetTrailersParameter.dwellTimeInDaysOperator;
            draft.getTrailersParameter.dwellTimeInDays = draft.incompleteGetTrailersParameter.dwellTimeInDays;
        } else {
            delete draft.getTrailersParameter.dwellTimeInDaysOperator;
            delete draft.getTrailersParameter.dwellTimeInDays;
        }
    },
    "Greif/Pages/TrailerTracking/ClearParameter": (draft: Draft<TrailerTrackingState>) => {
        draft.getTrailersParameter = {
            ...initialState.getTrailersParameter,
        };
        draft.incompleteGetTrailersParameter = {};
    },
    "Greif/Pages/TrailerTracking/ToggleFiltersOpen": (draft: Draft<TrailerTrackingState>) => {
        draft.filtersOpen = !draft.filtersOpen;
    },
    "Greif/Pages/TrailerTracking/ToggleSelectedTrailers": (
        draft: Draft<TrailerTrackingState>,
        action: { ids: string[] },
    ) => {
        for (const id of action.ids) {
            if (draft.selectedTrailersIds[id]) {
                delete draft.selectedTrailersIds[id];
            } else {
                draft.selectedTrailersIds[id] = true;
            }
        }
    },
    "Greif/Pages/TrailerTracking/ClearSelectedTrailers": (draft: Draft<TrailerTrackingState>) => {
        draft.selectedTrailersIds = {};
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifTrailerTrackingPageActions = Parameters<typeof reducer>[1];
export default reducer;
